import { render, staticRenderFns } from "./RentsPerToy.vue?vue&type=template&id=a9d84616"
import script from "./RentsPerToy.vue?vue&type=script&lang=js"
export * from "./RentsPerToy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports